import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import Snackbar from '@material-ui/core/Snackbar';

import { deleteMessage } from '../../store/actions/message.actions';
import SnackbarContent from './snackbar-content.component';

class SnackbarContainer extends React.Component {
  constructor(props) {
    super(props);

    this.handleClose = this.handleClose.bind(this);

    this.state = {
      id: '',
      type: '',
      duration: 0,
      text: '',
      snackbarOpen: false,
    };
  }
  componentWillReceiveProps(nextProps) {
    if (nextProps.messages.length > 0 && this.state.messageId !== nextProps.messages[0].id) {
      const { messages } = nextProps;

      this.setState({
        id: messages[0].id,
        type: messages[0].type,
        duration: messages[0].duration,
        text: messages[0].text,
        snackbarOpen: true,
      });
    }
  }

  handleClose() {
    const { id } = this.state;

    this.setState({
      id: '',
      type: '',
      duration: 0,
      text: '',
      snackbarOpen: false,
    });

    this.props.deleteMessage(id);
  }

  render() {
    if (!this.state.id) {
      return null;
    }

    return (
      <Snackbar
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        open={this.state.snackbarOpen}
        autoHideDuration={this.state.duration}
        onClose={this.handleClose}
      >
        <SnackbarContent
          variant={this.state.type}
          message={this.state.text}
          onClose={this.handleClose}
        />
      </Snackbar>
    );
  }
}

SnackbarContainer.propTypes = {
  messages: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number,
    type: PropTypes.string,
    duration: PropTypes.number,
    text: PropTypes.string,
  })).isRequired,
  deleteMessage: PropTypes.func.isRequired,
};

const mapStateToProps = ({ messaging: { messages } }) => ({
  messages,
});

export default connect(mapStateToProps, { deleteMessage })(SnackbarContainer);
